var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIconChevronDown = function SvgIconChevronDown(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 16 16"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.85 4.381a1.031 1.031 0 0 1-.07 1.381l-5.843 5.842a1.03 1.03 0 0 1-1.46 0l-5.84-5.842a1.033 1.033 0 0 1 1.46-1.46l5.112 5.113 5.112-5.112a1.03 1.03 0 0 1 1.381-.071l.079.07.07.08z"
  })));
};
export default SvgIconChevronDown;